<template>
    <div id="app">
        <router-view></router-view>

        <!-- Lišta se ukáže jen tehdy, když novou verzi nemůžeme načíst sami. -->
        <div id="newVersionBar" v-if="newVersionAvailable">
            <span class="mr-3">Je k dispozici nová verze aplikace.</span>
            <b-button id="newVersionReload" size="sm" variant="light" @click="reloadApp">
                Načíst znovu
            </b-button>
        </div>
    </div>
</template>

<script>
    import { appVersionService } from '@/services'

    // Aby se aplikace nemohla zacyklit, když by server vracel rozhozenou kombinaci
    // stare index.html + nove version.json: na stejnou verzi se sami načteme jen jednou.
    const AUTO_RELOAD_KEY = 'lekisAutoReloadedBuildId'

    export default {
        name: 'app',
        data: function () {
            return {
                newVersionAvailable: false,
                stopVersionWatch: null
            }
        },
        methods: {
            onNewVersion(newBuildId) {
                if (this.canReloadSilently(newBuildId)) {
                    this.rememberAutoReload(newBuildId)
                    this.reloadApp()
                    return
                }

                this.newVersionAvailable = true
            },

            /**
             * Novou verzi načteme sami jen tehdy, když uživatel o nic nepřijde.
             */
            canReloadSilently(newBuildId) {
                // Na shrnutí rezervace nikdy - tam už je hotová práce.
                if (this.$route.name === 'summary') {
                    return false
                }

                if (this.$store.state.form.hasUserData) {
                    return false
                }

                // Otevřený dialog nebo rozepsaný vstup znamená, že uživatel zrovna něco dělá.
                if (this.isModalOpen() || this.isTypingSomewhere()) {
                    return false
                }

                return !this.alreadyAutoReloadedTo(newBuildId)
            },

            isModalOpen() {
                return document.body.classList.contains('modal-open')
            },

            isTypingSomewhere() {
                let active = document.activeElement

                if (!active) {
                    return false
                }

                let tag = active.tagName && active.tagName.toLowerCase()

                return tag === 'input' || tag === 'textarea' || tag === 'select'
            },

            alreadyAutoReloadedTo(buildId) {
                try {
                    return window.sessionStorage.getItem(AUTO_RELOAD_KEY) === buildId
                } catch (e) {
                    // Např. soukromé okno, kde sessionStorage není k dispozici.
                    return false
                }
            },

            rememberAutoReload(buildId) {
                try {
                    window.sessionStorage.setItem(AUTO_RELOAD_KEY, buildId)
                } catch (e) {
                    // Bez pojistky proti zacyklení to přežijeme, načtení je důležitější.
                }
            },

            reloadApp() {
                window.location.reload()
            }
        },
        created() {
            this.stopVersionWatch = appVersionService.watchForNewVersion(this.onNewVersion)
        },
        beforeDestroy() {
            this.stopVersionWatch && this.stopVersionWatch()
        }
    }
</script>

<style>
    .app {
        background: -webkit-linear-gradient(left, #3931af, #00c6ff);
    }
    .footer-text {
        color: black !important
    }

    #newVersionBar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1050;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0.5rem 1rem;
        background-color: #3931af;
        color: #fff;
        text-align: center;
    }
</style>
